import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout';
import TermsOfUseEditor from './TermsOfUseEditor';
import { isAdminUser } from '../../../lib/utils';


const title = 'Regulamin portalu';

export default {

  path: '/terms_of_use_editor',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        const isAdmin = await isAdminUser(ctx);

        if (!isAdmin) {
          return { redirect: '/' };
        }

        return {
          title,
          chunk: 'TermsOfUseEditor',
          component: <ServicesLayout isAdmin><TermsOfUseEditor title={title} isAdmin={isAdmin} user={state.user} /></ServicesLayout>,
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/terms_of_use_editor/index.js